import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { ValueStackSection } from '../components/ValueStackSection';
import { TestimonialSection } from '../components/TestimonialSection';
import { ClosingSection } from '../components/ClosingSection';
export function LandingPage() {
  return <main className="w-full min-h-screen" style={{
    background: '#0A1628'
  }} data-id="element-195">
      <HeroSection data-id="element-196" />
      <PainSection data-id="element-197" />
      <SolutionSection data-id="element-198" />
      <ValueStackSection data-id="element-199" />
      <TestimonialSection data-id="element-200" />
      <ClosingSection data-id="element-201" />
    </main>;
}